import {endpoints} from './endpoints'
import request from '../request'

export function projectUserExport(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.projectUserExport,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function exportStatusRdiByProject(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.exportStatusRdiByProject,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function exportStatusEntregaByProject(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.exportStatusRdiByProject,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function exportTasksByProject(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.exportTasksByProject,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function exportDocumentsListing(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.exportDocumentsListing,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}